import { DiscountCommissionIcon } from "assets/icons";
import { t } from "i18next";
import { Icon } from "ui";

import { CommissionLabelProps } from "./CommissionLabel.types";

import styles from "./CommissionLabel.module.scss";

const CommissionLabel = ({
  commissionValue,
  iconSize = 18,
  fontSize = 14,
  fixed = false
}: CommissionLabelProps) => {
  return (
    <div className={styles.comissionLabel} style={{ fontSize }}>
      <Icon as={DiscountCommissionIcon} boxSize={iconSize} />
      <div
        className={styles.comissionLabel_value}
      >{`${commissionValue.toLocaleString("en-US")} FCFA`}</div>
      {`${fixed ? `${t("Fixed")} ` : ""} ${t("Commission")}`}
    </div>
  );
};

export default CommissionLabel;
